"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledSuperCashbackIcon = exports.StyledPriceLayout = exports.StyledInstantConfirmIcon = exports.StyledIconsLayout = exports.StyledHotPriceIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _userflow = require("../../icons-react/userflow");
var _InstantConfirm = _interopRequireDefault(require("../../icons-react/userflow/InstantConfirm"));
var _SuperCashBack = _interopRequireDefault(require("../CashBack/SuperCashBack"));
var _Button = _interopRequireDefault(require("../Button"));
var _HotelOfferPrice = _interopRequireDefault(require("../HotelOfferPrice"));
var _excluded = ["price", "hotPrice", "instantConfirm", "onClick", "isHotelOnly", "hasSuperCashback"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelOfferButton = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var price = _ref.price,
    hotPrice = _ref.hotPrice,
    instantConfirm = _ref.instantConfirm,
    onClick = _ref.onClick,
    isHotelOnly = _ref.isHotelOnly,
    hasSuperCashback = _ref.hasSuperCashback,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var count = [hotPrice, instantConfirm, hasSuperCashback].filter(Boolean).length;
  var tripleStickersLayout = count === 3;
  var doubleStickersLayout = count === 2;
  var leftToRight = hasSuperCashback && instantConfirm || hotPrice && instantConfirm;
  var rightToLeft = hotPrice && hasSuperCashback;
  var classNames = [tripleStickersLayout && 'triple', doubleStickersLayout && leftToRight && 'left-to-right', doubleStickersLayout && rightToLeft && 'right-to-left'].filter(Boolean).join(' ');
  return /*#__PURE__*/_react["default"].createElement(StyledHotelOfferButton, (0, _extends2["default"])({}, rest, {
    onClick: onClick
  }), !!count && /*#__PURE__*/_react["default"].createElement(StyledIconsLayout, {
    className: classNames
  }, hotPrice && /*#__PURE__*/_react["default"].createElement(StyledHotPriceIcon, null), hasSuperCashback && /*#__PURE__*/_react["default"].createElement(StyledSuperCashbackIcon, {
    size: "custom"
  }), instantConfirm && /*#__PURE__*/_react["default"].createElement(StyledInstantConfirmIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledPriceLayout, null, /*#__PURE__*/_react["default"].createElement(_HotelOfferPrice["default"], {
    price: price,
    noStickers: !count
  }), !isHotelOnly && /*#__PURE__*/_react["default"].createElement(StyledSubText, {
    noStickers: !count
  }, "\u0441 \u043F\u0435\u0440\u0435\u043B\u0451\u0442\u043E\u043C")));
});
HotelOfferButton.defaultProps = {
  hotPrice: false,
  instantConfirm: false,
  isActive: false,
  cancellationPolicy: null
};
HotelOfferButton.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  price: _propTypes["default"].number.isRequired,
  hotPrice: _propTypes["default"].bool,
  instantConfirm: _propTypes["default"].bool,
  cancellationPolicy: _propTypes["default"].shape({
    kind: _propTypes["default"].string.isRequired,
    description: _propTypes["default"].string.isRequired
  }),
  isActive: _propTypes["default"].bool,
  hasSuperCashback: _propTypes["default"].bool
};
var StyledIconsLayout = exports.StyledIconsLayout = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferButton__StyledIconsLayout",
  componentId: "sc-161lx2c-0"
})(["flex-shrink:0;width:36px;height:48px;display:flex;justify-content:center;padding-top:7px;padding-left:3px;position:relative;"]);
var StyledPriceLayout = exports.StyledPriceLayout = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferButton__StyledPriceLayout",
  componentId: "sc-161lx2c-1"
})(["flex-grow:1;"]);
var StyledHotPriceIcon = exports.StyledHotPriceIcon = (0, _styledComponents["default"])(_userflow.HotPriceCircle).withConfig({
  displayName: "HotelOfferButton__StyledHotPriceIcon",
  componentId: "sc-161lx2c-2"
})(["width:24px;height:24px;.triple &{position:absolute;transform:rotate(11deg);width:15px;height:15px;left:17px;top:2px;}.right-to-left &{position:absolute;transform:rotate(11deg);width:20px;height:17px;top:6px;left:15px;}.left-to-right &{position:absolute;width:20px;height:17px;top:6px;left:5px;transform:rotate(-5deg);}"]);
var StyledInstantConfirmIcon = exports.StyledInstantConfirmIcon = (0, _styledComponents["default"])(_InstantConfirm["default"]).withConfig({
  displayName: "HotelOfferButton__StyledInstantConfirmIcon",
  componentId: "sc-161lx2c-3"
})(["transform:rotate(-20deg);width:22px;height:32px;.triple &{position:absolute;top:21px;left:16px;transform:rotate(5deg);width:17px;height:21px;}.left-to-right &{position:absolute;width:23px;height:23px;transform:rotate(5deg);left:13px;top:18px;}"]);
var StyledSuperCashbackIcon = exports.StyledSuperCashbackIcon = (0, _styledComponents["default"])(_SuperCashBack["default"]).withConfig({
  displayName: "HotelOfferButton__StyledSuperCashbackIcon",
  componentId: "sc-161lx2c-4"
})(["width:29px;height:30px;transform:rotate(-10deg) translate(-2px,-5px);.triple &{position:absolute;width:19px;height:20px;left:2px;top:14px;}.right-to-left &{position:absolute;top:21px;left:5px;width:17px;height:21px;}.left-to-right &{position:absolute;width:20px;height:20px;top:3px;left:1px;transform:rotate(-10deg);}"]);
var StyledSubText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferButton__StyledSubText",
  componentId: "sc-161lx2c-5"
})(["", " color:", ";font-size:9px;line-height:12px;text-align:left;", ""], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.blackLight;
}, function (_ref2) {
  var noStickers = _ref2.noStickers;
  return noStickers && (0, _styledComponents.css)(["text-align:center;"]);
});
var StyledHotelOfferButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelOfferButton__StyledHotelOfferButton",
  componentId: "sc-161lx2c-6"
})(["display:flex;align-items:center;width:100%;height:48px;padding:0;font-family:'Backpack';border-radius:3px;box-shadow:0 2px 4px 0 rgba(0,0,0,0.1);background:", ";border-color:", ";", ";"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.nomad;
}, function (props) {
  return props.isActive && (0, _styledComponents.css)(["box-shadow:0 2px 0 0 #b27e01;background-image:linear-gradient(to bottom,#ffe700,#ffd000);border-color:transparent !important;"]);
});
HotelOfferButton.HotelOfferPrice = _HotelOfferPrice["default"];
HotelOfferButton.displayName = 'HotelOfferButton';
var _default = exports["default"] = HotelOfferButton;